// history.js
import browserHistory from './browserHistory'
import { shallowEqual, useSelector } from 'react-redux'
import { isAuthorizationStartedSelector } from '../redux/modules/auth'

const selector = useSelector

// export default createBrowserHistory({
//   /* pass a configuration object here if needed */
// })

const HistoryHelper = {
  store: null,

  push(location, force = false) {
    if (!force) {
      if (!this.store) {
        return false
      }

      let state = this.store.getState()
      if (!state?.auth) {
        return false
      }

      if (!!state.auth.isAuthorizationStarted) {
        return false
      }
    }

    browserHistory.push(location)
    return true
  }
}

export default HistoryHelper